import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../assets/images/videoOutput.png'
import _imports_1 from '../../assets/images/assetediting1.png'
import _imports_2 from '../../assets/images/assetediting.gif'
import _imports_3 from '../../assets/images/videoOutput.gif'


const _hoisted_1 = { class: "coreCnetentLeft" }
const _hoisted_2 = { class: "coreCnetentLeftBody" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_4 = {
  key: 0,
  src: _imports_1,
  alt: ""
}
const _hoisted_5 = {
  key: 0,
  class: "coreCnetentLeftTo"
}
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "titleto" }
const _hoisted_8 = { class: "coreCnetentLeftToDes" }
const _hoisted_9 = {
  key: 1,
  class: "coreCnetentLeftTo"
}
const _hoisted_10 = { class: "coreCnetentLeftToBody assetediting" }
const _hoisted_11 = { class: "title" }
const _hoisted_12 = { class: "titleto" }
const _hoisted_13 = { class: "coreCnetentLeftToDes" }
const _hoisted_14 = {
  key: 2,
  class: "texture",
  src: _imports_2,
  alt: ""
}
const _hoisted_15 = {
  key: 3,
  class: "texture",
  src: _imports_3,
  alt: ""
}

import { ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ZhCoreFunctionsTab2',
  setup(__props) {

const coreCnetentToRef = ref(true);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "coreCnetentLeftTab",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (coreCnetentToRef.value = true)),
        style: {"padding-left":"34px"}
      }, [
        (coreCnetentToRef.value)
          ? (_openBlock(), _createElementBlock("img", _hoisted_3))
          : _createCommentVNode("", true),
        _createElementVNode("p", {
          style: _normalizeStyle({
            'line-height': '26px',
            color: coreCnetentToRef.value ? '#52595d' : '#52595d',
          })
        }, _toDisplayString(_ctx.$t("home.tap2_button_text1")), 5)
      ]),
      _createElementVNode("div", {
        class: "Material",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (coreCnetentToRef.value = false)),
        style: {"padding-left":"34px"}
      }, [
        (!coreCnetentToRef.value)
          ? (_openBlock(), _createElementBlock("img", _hoisted_4))
          : _createCommentVNode("", true),
        _createElementVNode("p", {
          style: _normalizeStyle({
            color: coreCnetentToRef.value ? '#52595d' : '#fff',
          })
        }, _toDisplayString(_ctx.$t("home.tap2_button_text2")), 5)
      ])
    ]),
    (coreCnetentToRef.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(["coreCnetentLeftToBody videoOutput", coreCnetentToRef.value ? 'coreCnetentLeftToBodyGradlent' : ''])
          }, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("home.core_funs_contents3_top")), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("home.core_funs_contents3_center")), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("home.core_funs_contents3_bom")), 1)
          ], 2)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("home.core_funs_contents4_top")), 1),
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("home.core_funs_contents4_center")), 1),
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("home.core_funs_contents4_bom")), 1)
          ])
        ])),
    (!coreCnetentToRef.value)
      ? (_openBlock(), _createElementBlock("img", _hoisted_14))
      : (_openBlock(), _createElementBlock("img", _hoisted_15))
  ]))
}
}

})